"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Banner_1 = __importDefault(require("../banner/Banner"));
var ChildrenUtils_1 = require("../../common/ChildrenUtils");
var BannerType = (react_1.default.createElement(Banner_1.default, null)).type;
var PrimaryContent = function (props) {
    var children = props.children, classes = props.classes, onClick = props.onClick, otherProps = __rest(props, ["children", "classes", "onClick"]);
    var banners = ChildrenUtils_1.filterChildrenIn(children, BannerType);
    var empty = react_1.default.Children.toArray(children).filter(function (child) {
        return child.props.className && child.props.className.indexOf('fds-list-empty-message') !== -1;
    }).length > 0;
    return (react_1.default.createElement("div", __assign({ className: classnames_1.default('fds-list-item-primary', classes), onClick: onClick }, otherProps), !empty ? (react_1.default.createElement(react_1.default.Fragment, null,
        banners,
        react_1.default.createElement("div", { className: "fds-list-item-body" }, ChildrenUtils_1.filterChildrenOut(children, BannerType)))) : (children)));
};
PrimaryContent.defaultProps = {};
exports.default = PrimaryContent;
